import { Box, Heading, Text, VStack, useColorModeValue } from "@chakra-ui/react";

import { useAppState } from "~/hooks/useAppState";
import { useAppStore } from "~/store";

export const Vitals = () => {
  const { currentMember } = useAppState("currentMember");
  const setCurrentMember = useAppStore((state) => state.setCurrentMember);

  // Color mode values
  const cardBg = useColorModeValue("white", "gray.700");
  const cardBorder = useColorModeValue("gray.200", "gray.600");

  if (!currentMember) {
    return (
      <Box p={4} textAlign="center">
        <Text>Please select a member from the dropdown above to view vitals data.</Text>
      </Box>
    );
  }

  return (
    <Box p={4}>
      <VStack spacing={4} align="start">
        <Heading size="md" mb={4}>
          Vitals for {currentMember.name}
        </Heading>

        <Box
          w="100%"
          borderWidth="1px"
          borderRadius="lg"
          p={8}
          bg={cardBg}
          borderColor={cardBorder}
          boxShadow="sm"
          textAlign="center"
        >
          <Heading size="lg" color="gray.500">
            Coming Soon
          </Heading>
          <Text mt={4} color="gray.500">
            Vitals tracking functionality will be available in a future update.
          </Text>
        </Box>
      </VStack>
    </Box>
  );
};

export default Vitals;
